/*
  Animations d'entrée qui se rejouent à chaque retour de la section à
  l'écran (le scroll-trigger de Dawn ne joue qu'une fois) : fondu de chaque
  section de la page, puis, à l'intérieur :
  « Our Specialties » (multicolumn), « From Your Idea... » (process-steps)
  et le titre du CTA final de la page PVC 3D (pvc_cta).
  Ce script ne fait que poser .cpc-reveal sur la liste et basculer .is-open ;
  les animations elles-mêmes sont dans assets/custom.css.
*/
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  function init() {
    const lists = document.querySelectorAll(
      '.multicolumn .multicolumn-list, .process-steps, [id$="__pvc_cta"] .rich-text__heading'
    );

    // Éditeur de thème : cartes dépliées, pas d'animation.
    if (window.Shopify && Shopify.designMode) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio >= 0.15) {
            entry.target.classList.add('is-open');
          } else if (!entry.isIntersecting) {
            // Replié seulement une fois complètement sorti de l'écran, pour
            // que l'effet recommence au prochain passage sans clignoter.
            entry.target.classList.remove('is-open');
          }
        });
      },
      { threshold: [0, 0.15] }
    );

    // Mobile : les cartes de « Our Specialties » sont empilées, donc
    // observées une à une — chacune apparaît en fondu en entrant à l'écran.
    // Ailleurs (et sur desktop), la liste entière.
    const cardsOneByOne = window.matchMedia('(max-width: 749px)').matches;

    lists.forEach((list) => {
      list.classList.add('cpc-reveal');
      if (cardsOneByOne && list.classList.contains('multicolumn-list')) {
        list.classList.add('cpc-reveal--items');
        list.querySelectorAll('.multicolumn-list__item').forEach((item) => observer.observe(item));
      } else {
        observer.observe(list);
      }
    });

    // Fondu d'entrée de chaque section de la page (sauf la première, le
    // hero, déjà visible au chargement). Visible dès que son haut entre
    // dans l'écran ; recachée seulement une fois complètement sortie, pour
    // que le fondu se rejoue au prochain passage (en descendant comme en
    // remontant). Le fondu lui-même est dans assets/custom.css.
    const sections = document.querySelectorAll('#MainContent > .shopify-section:not(:first-child)');
    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.target.classList.toggle('cpc-section-fade--visible', entry.isIntersecting);
        });
      },
      { rootMargin: '0px 0px -8% 0px' }
    );
    sections.forEach((section) => {
      section.classList.add('cpc-section-fade');
      sectionObserver.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
